export function defaultAiSettings()
{
    return {
        providers: [],
        models: [],
        features: {
            'text': null,
            'text-fast': null,
            'images': null,
            'vision': null,
            'embeddings': null
        }
    };
}
